<template>
  <div class="landing-page">
    <template v-if="!notExists">
      <header class="generic-login__header">
        <div class="brand-strip">
          <div class="brand-strip__segment brand-strip__segment--boticario"></div>
          <div class="brand-strip__segment brand-strip__segment--qdb"></div>
          <div class="brand-strip__segment brand-strip__segment--oui"></div>
          <div class="brand-strip__segment brand-strip__segment--eudora"></div>
        </div>
        <div class="generic-login__header-inner">
          <img src="/img/logo.png" alt="Grupo Boticário" class="generic-login__logo" />
        </div>
      </header>

      <div class="landing-body">
        <div class="landing-inner">
        <h1 class="landing-greeting">Olá, {{ displayGreetingName }}!</h1>
        <p class="landing-subtitle">Preencha os campos abaixo para visualizar suas ofertas</p>

        <div class="landing-card">
          <p class="landing-card__label">Digite os 4 primeiros dígitos do seu CPF ou CNPJ</p>

          <form id="landing-form" class="landing-form" @submit.prevent="dologin">
            <div class="landing-digits" role="group" aria-label="Quatro primeiros dígitos do documento">
              <div
                v-for="idx in 4"
                :key="idx - 1"
                class="landing-digit-shell"
                :class="canSubmit ? 'landing-digit-shell--ready' : 'landing-digit-shell--pending'"
              >
                <input
                  ref="digitInput"
                  :value="digits[idx - 1]"
                  type="text"
                  inputmode="numeric"
                  maxlength="1"
                  class="landing-digit-input"
                  :disabled="loading"
                  :aria-label="`Dígito ${idx}`"
                  @input="onDigitInput($event, idx - 1)"
                  @keydown="onDigitKeydown($event, idx - 1)"
                  @paste="onDigitsPaste"
                />
                <span
                  v-if="!digits[idx - 1]"
                  class="landing-digit-placeholder"
                  aria-hidden="true"
                >0</span>
              </div>
            </div>

            <div v-if="allFieldErrors.length" class="landing-errors">
              <b
                v-for="error in allFieldErrors"
                :key="error"
                :class="classMessage"
                class="landing-error-text"
              >{{ error }}</b>
            </div>

            <button
              v-if="!loading"
              type="submit"
              class="landing-submit"
              :disabled="!canSubmit"
            >
              CONTINUAR
            </button>
          </form>

          <div class="landing-loading">
            <ProgressLoading :loading="loading" />
          </div>
        </div>
        </div>
      </div>
    </template>

    <template v-else>
      <header class="generic-login__header">
        <div class="brand-strip">
          <div class="brand-strip__segment brand-strip__segment--boticario"></div>
          <div class="brand-strip__segment brand-strip__segment--qdb"></div>
          <div class="brand-strip__segment brand-strip__segment--oui"></div>
          <div class="brand-strip__segment brand-strip__segment--eudora"></div>
        </div>
        <div class="generic-login__header-inner">
          <img src="/img/logo.png" alt="Grupo Boticário" class="generic-login__logo" />
        </div>
      </header>
      <div class="landing-expired">
        <h2 class="landing-expired__title">Link de acesso vencido! Por favor, use um link válido.</h2>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import ProgressLoading from '../../modules/auth/components/ProgressLoading.vue';
import { ActionGetIPAddress } from '@/utils/helpers';
import { markCampaignPopupPending } from '@/pages/home/utils/campaignPopup';

export default {
  components: {
    ProgressLoading,
  },
  name: 'Landing',
  mixins: [validationMixin],
  validations: {
    form: {
      accessdoc: { required, minLength: minLength(4) },
    },
  },
  data: () => ({
    themeBackground: null,
    imageBackground: null,
    form: {
      accessdoc: null,
      accesscode: null,
      termsAcepted: false,
    },
    digits: ['', '', '', ''],
    loginApiError: '',
    error: {
      alert: false,
      status: null,
      message: null,
    },
    accessname: '',
    loading: false,
    notExists: false,
    largura: null,
    ipUser: null,
  }),
  computed: {
    displayGreetingName() {
      const n = String(this.accessname || '').trim();
      if (!n) return '';
      return n
        .toLowerCase()
        .split(/\s+/)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    },
    canSubmit() {
      return this.digits.length === 4 && this.digits.every((d) => d && /\d/.test(d));
    },
    validationErrors() {
      const errors = [];
      if (!this.$v.form.accessdoc.$dirty) return errors;
      !this.$v.form.accessdoc.required && errors.push('Campo é obrigatório!');
      !this.$v.form.accessdoc.minLength &&
        errors.push('O CPF/CNPJ não está completo!');
      return errors;
    },
    allFieldErrors() {
      const out = [...this.validationErrors];
      if (this.loginApiError) out.push(this.loginApiError);
      return out;
    },
    classMessage() {
      return {
        'text-danger': this.error.status === 'ERROR',
        'text-muted': this.error.status !== 'ERROR',
      };
    },
  },
  watch: {
    '$route.params.mailing': {
      immediate: false,
      async handler(newCode, oldCode) {
        if (newCode && newCode !== oldCode) {
          await this.loadMailingData();
        }
      },
    },
    digits: {
      deep: true,
      handler(arr) {
        this.form.accessdoc = arr.join('');
      },
    },
  },
  methods: {
    ...mapActions('auth', [
      'ActionGetMailingFirstName',
      'ActionMailingDoLogin',
      'ActionDoRegisterSession',
    ]),
    focusDigit(index) {
      this.$nextTick(() => {
        const refs = this.$refs.digitInput;
        const arr = Array.isArray(refs) ? refs : refs ? [refs] : [];
        const el = arr[index];
        if (el && typeof el.focus === 'function') el.focus();
      });
    },
    onDigitInput(e, idx) {
      let v = String(e.target.value || '').replace(/\D/g, '').slice(-1);
      this.$set(this.digits, idx, v);
      e.target.value = v;
      if (v && idx < 3) {
        this.focusDigit(idx + 1);
      }
    },
    onDigitKeydown(e, idx) {
      if (e.key === 'Backspace' && !this.digits[idx] && idx > 0) {
        e.preventDefault();
        this.$set(this.digits, idx - 1, '');
        this.focusDigit(idx - 1);
      }
    },
    onDigitsPaste(e) {
      e.preventDefault();
      const text = (e.clipboardData || window.clipboardData).getData('text');
      const nums = String(text).replace(/\D/g, '').slice(0, 4).split('');
      for (let i = 0; i < 4; i++) {
        this.$set(this.digits, i, nums[i] || '');
      }
      const next = Math.min(nums.length, 3);
      this.focusDigit(nums.length >= 4 ? 3 : next);
    },
    clearDigits() {
      this.digits = ['', '', '', ''];
      this.form.accessdoc = '';
    },
    async loadMailingData(retryCount = 0) {
      this.notExists = false;
      this.accessname = '';
      this.form.accessdoc = null;
      this.clearDigits();
      this.loading = true;

      this.form.accesscode = this.$route.params.mailing;

      const maxRetries = 2;

      try {
        if (retryCount === 0) {
          try {
            await this.ActionDoRegisterSession();
            await new Promise((resolve) => setTimeout(resolve, 100));
          } catch {
            // continua mesmo se falhar, cookie pode já existir
          }
        }

        const result = await this.ActionGetMailingFirstName({
          AccessCode: this.form.accesscode,
          IP: this.ipUser || '',
          OS: navigator.platform,
        });

        if (result && result.data && result.data.code !== 200) {
          this.notExists = true;
        } else if (result && result.data && result.data.results) {
          this.accessname = result.data.results.FirstName;
        } else {
          this.notExists = true;
        }
      } catch (error) {
        if (error?.status === 401 && retryCount < maxRetries) {
          try {
            await this.ActionDoRegisterSession();
            await new Promise((resolve) => setTimeout(resolve, 200));
            return await this.loadMailingData(retryCount + 1);
          } catch {
            // sem retry disponível
          }
        }
        this.notExists = true;
      } finally {
        this.loading = false;
      }
    },
    async dologin() {
      if (!this.canSubmit) return;
      this.form.accessdoc = this.digits.join('');
      this.loginApiError = '';
      this.error.status = 'ERROR';
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      try {
        try {
          await this.ActionDoRegisterSession();
          await new Promise((resolve) => setTimeout(resolve, 100));
        } catch {
          // continua mesmo se falhar
        }

        await this.ActionMailingDoLogin({
          DocNumber: this.form.accessdoc,
          AccessCode: this.form.accesscode,
          DeviceName: process.env.VUE_APP_API_DEVICE,
          IP: this.ipUser || '',
          OS: navigator.platform,
        });
        markCampaignPopupPending();
        this.$router.push('/');
      } catch {
        this.loginApiError = 'Ocorreu um erro ao autenticar, dados informados inválidos.';
        this.error.status = 'ERROR';
      } finally {
        this.loading = false;
      }
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          break;
        } catch (error) {
          console.log('Erro ao obter o endereço IP. Tentando novamente...');
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          'Número máximo de tentativas atingido. Não foi possível obter o endereço IP.',
        );
      }
    },
  },
  async created() {
    await this.getIPAddressUser();
    this.largura = window.screen.width;
    await this.loadMailingData();
  },
};
</script>

<style scoped>
.landing-page {
  min-height: 100dvh;
  background: #fff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  display: flex;
  flex-direction: column;
}

.generic-login__header {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #dfdfdf;
}

.brand-strip {
  display: flex;
  width: 100%;
  height: 10px;
}

.brand-strip__segment {
  flex: 1;
}

.brand-strip__segment--boticario {
  background: #2da072;
}

.brand-strip__segment--qdb {
  background: #d245ad;
}

.brand-strip__segment--oui {
  background: #8d2231;
}

.brand-strip__segment--eudora {
  background: #613a53;
}

.generic-login__header-inner {
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.generic-login__logo {
  width: 146px;
  height: auto;
}

.landing-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 20px 28px;
  min-height: 0;
  overflow-y: auto;
  box-sizing: border-box;
}

.landing-inner {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 12px 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.landing-greeting {
  margin: 0 auto 10px;
  width: 100%;
  max-width: 22em;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e1e24;
  text-align: center;
  line-height: 1.25;
}

.landing-subtitle {
  margin: 0 auto 24px;
  width: 60%;
  max-width: 100%;
  font-size: 0.95rem;
  font-weight: 500;
  color: #1e1e24;
  text-align: center;
  line-height: 1.45;
}

.landing-card {
  width: 100%;
  max-width: 480px;
  background: #f5f5f5;
  border-radius: 22px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 10px 28px rgba(0, 0, 0, 0.1),
    0 24px 48px -16px rgba(0, 0, 0, 0.12);
  padding: 28px 24px 26px;
  box-sizing: border-box;
}

.landing-card__label {
  margin: 0 auto 20px;
  width: 100%;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6b6b6b;
  text-align: center;
  line-height: 1.35;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.landing-card__label::-webkit-scrollbar {
  display: none;
}

@media (max-width: 380px) {
  .landing-card__label {
    font-size: 0.7rem;
  }
}

.landing-form {
  margin: 0;
}

.landing-digits {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

@media (max-width: 360px) {
  .landing-digits {
    gap: 10px;
  }
}

.landing-digit-shell {
  position: relative;
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
}

.landing-digit-shell--pending {
  background: #e8e8e8;
  border: 2px solid #8a8a8a;
}

.landing-digit-shell--ready {
  background: #fff;
  border: 3px solid #12654c;
}

@media (min-width: 400px) {
  .landing-digit-shell {
    width: 58px;
    height: 58px;
  }
}

.landing-digit-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  pointer-events: none;
  z-index: 1;
}

.landing-digit-shell--pending .landing-digit-placeholder {
  color: #b0b0b0;
}

.landing-digit-shell--ready .landing-digit-placeholder {
  color: #12654c;
}

.landing-digit-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 1.35rem;
  font-weight: 600;
  color: #333438;
  padding: 0;
  box-sizing: border-box;
  font-family: inherit;
  z-index: 2;
}

.landing-digit-shell--pending .landing-digit-input {
  caret-color: #555;
}

.landing-digit-shell--ready .landing-digit-input {
  caret-color: #12654c;
}

.landing-digit-input:focus {
  outline: none;
}

.landing-digit-shell--pending .landing-digit-input:focus {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
}

.landing-digit-shell--ready .landing-digit-input:focus {
  box-shadow: 0 0 0 3px rgba(18, 101, 76, 0.25);
}

.landing-digit-input:disabled {
  opacity: 0.6;
}

.landing-errors {
  text-align: center;
  margin-bottom: 12px;
}

.landing-error-text {
  display: block;
  font-size: 12px;
}

.landing-submit {
  width: 100%;
  border: none;
  border-radius: 12px;
  background: #15795b;
  color: #fff;
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  min-height: 50px;
  cursor: pointer;
  margin-top: 8px;
}

.landing-submit:disabled {
  background: #c5cbc7;
  color: rgba(255, 255, 255, 0.75);
  opacity: 1;
  cursor: not-allowed;
}

.landing-submit:not(:disabled):hover {
  background: #12654c;
}

.landing-loading {
  margin-top: 12px;
}

.landing-expired {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fff;
  text-align: center;
}

.landing-expired__title {
  margin: 0;
  color: #175452;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.4;
  max-width: 360px;
}
</style>
